import React from 'react';

import { createComponent, PropTypes } from 'console-kit';

import AuthFooter from './AuthFooter';

const AuthScreenLayout = createComponent({
  displayName: 'AuthScreenLayout',
  propTypes:   {
    children: PropTypes.element.isRequired,
  },
  render(props) {
    return (
      <div className="pageWrapper">
        <div className="panel panel-login fade-in t4">{props.children}</div>
        <AuthFooter />
      </div>
    );
  },
});

export default AuthScreenLayout;
